var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      !_vm.hideData && !_vm.orderRemoved
        ? _c("div", { staticClass: "container pt-4 mt-5 pb-5" }, [
            _c("div", { staticClass: "row justify-content-center text-left" }, [
              _c("h3", { staticClass: "Regular center h0 widthFull" }, [
                _c("b", [_vm._v("Pratica N. " + _vm._s(_vm.item.code))])
              ]),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-4 pt-md-4 mt-3 center mb-3 text-right" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-primary m-2 btn-sm ml-md-5",
                      attrs: { to: { name: "pratiche" } }
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: "arrow-left", size: "1x" }
                      }),
                      _vm._v("\r\n          Indietro\r\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "form",
              {
                staticClass: "pb-5 pt-4  black vaillantCont widthFull",
                attrs: { id: "registration-form" }
              },
              [
                _c(
                  "div",
                  { staticClass: "row justify-content-center pb-5 " },
                  [
                    _vm.item.client_type == "Persona fisica"
                      ? [
                          _c("div", { staticClass: "col-md-12" }, [
                            _vm.item.client_type == "Partita IVA"
                              ? _c(
                                  "h4",
                                  { staticClass: "widthFull center black" },
                                  [
                                    _vm._v(
                                      "\r\n              Completa i dati del cliente finale ("
                                    ),
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.item.client_name) +
                                          " " +
                                          _vm._s(_vm.item.client_lastname)
                                      )
                                    ]),
                                    _vm._v(")\r\n            ")
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-md-4 mb-3",
                              staticStyle: { opacity: "1" }
                            },
                            [
                              _c("div", { staticClass: "group custInput" }, [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.client_ownership,
                                        expression: "client_ownership"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required: true,
                                          max: 63,
                                          min: 2
                                        },
                                        expression:
                                          "{required:true, max: 63, min: 2}"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    class: {
                                      "is-invalid": _vm.errors.has(
                                        "client_ownership"
                                      ),
                                      valid: !!_vm.client_ownership
                                    },
                                    attrs: {
                                      type: "text",
                                      autocomplete: "randomq",
                                      id: "client_ownership",
                                      name: "client_ownership",
                                      "data-vv-as": "Titolo di possesso"
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.client_ownership = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "option",
                                      { attrs: { value: "Proprietario" } },
                                      [_vm._v("Proprietario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "Usufruttuario" } },
                                      [_vm._v("Usufruttuario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "Locatario" } },
                                      [_vm._v("Locatario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value: "Promissario acquirente"
                                        }
                                      },
                                      [_vm._v("Promissario acquirente")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value:
                                            "Familiare convivente del possessore/detentore"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Familiare convivente del possessore/detentore"
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "Erede" } },
                                      [_vm._v("Erede")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value: "Coniuge separato assegnatario"
                                        }
                                      },
                                      [_vm._v("Coniuge separato assegnatario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value:
                                            "Socio di cooperativa a proprietà indivisa"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Socio di cooperativa a proprietà indivisa"
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value:
                                            "Socio di cooperativa a proprietà divisa"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Socio di cooperativa a proprietà divisa"
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "niceInputLabel",
                                    attrs: { for: "client_ownership" }
                                  },
                                  [_vm._v("Titolo di possesso *")]
                                ),
                                _vm._v(" "),
                                _vm.errors.has("client_ownership")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\r\n                " +
                                            _vm._s(
                                              _vm.errors.first(
                                                "client_ownership"
                                              )
                                            ) +
                                            "\r\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ]
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.item.client_type == "Partita IVA"
                      ? [
                          _c("div", { staticClass: "col-md-12" }, [
                            _vm.item.client_type == "Partita IVA"
                              ? _c(
                                  "h4",
                                  { staticClass: "widthFull center black" },
                                  [
                                    _vm._v(
                                      "\r\n              Completa i dati del cliente finale ("
                                    ),
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.item.client_name) +
                                          " " +
                                          _vm._s(_vm.item.client_lastname)
                                      )
                                    ]),
                                    _vm._v(")\r\n            ")
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-4" }, [
                            _c("div", { staticClass: "group custInput" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.azienda,
                                    expression: "azienda"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true, max: 128, min: 3 },
                                    expression:
                                      "{required:true, max: 128, min: 3}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("azienda"),
                                  valid: !!_vm.azienda
                                },
                                attrs: {
                                  type: "text",
                                  id: "azienda",
                                  name: "azienda",
                                  "data-vv-as": "Ragione sociale"
                                },
                                domProps: { value: _vm.azienda },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.azienda = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "azienda" }
                                },
                                [_vm._v("Ragione sociale * ")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("azienda")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\r\n                " +
                                          _vm._s(_vm.errors.first("azienda")) +
                                          "\r\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-4" }, [
                            _c("div", { staticClass: "group custInput" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.partita_iva,
                                    expression: "partita_iva"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      required: true,
                                      partitaIva: true,
                                      max: 11,
                                      min: 11
                                    },
                                    expression:
                                      "{required: true, partitaIva: true, max: 11, min: 11,}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("partita_iva"),
                                  valid: !!_vm.partita_iva
                                },
                                attrs: {
                                  type: "text",
                                  id: "partita_iva",
                                  name: "partita_iva",
                                  "data-vv-as": "Partita IVA"
                                },
                                domProps: { value: _vm.partita_iva },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.partita_iva = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "partita_iva" }
                                },
                                [_vm._v("Partita IVA *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("partita_iva")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\r\n                " +
                                          _vm._s(
                                            _vm.errors.first("partita_iva")
                                          ) +
                                          "\r\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-md-4 mb-3",
                              staticStyle: { opacity: "1" }
                            },
                            [
                              _c("div", { staticClass: "group custInput" }, [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.client_ownership,
                                        expression: "client_ownership"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required: true,
                                          max: 63,
                                          min: 2
                                        },
                                        expression:
                                          "{required:true, max: 63, min: 2}"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    class: {
                                      "is-invalid": _vm.errors.has(
                                        "client_ownership"
                                      ),
                                      valid: !!_vm.client_ownership
                                    },
                                    attrs: {
                                      type: "text",
                                      autocomplete: "randomq",
                                      id: "client_ownership",
                                      name: "client_ownership",
                                      "data-vv-as": "Titolo di possesso"
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.client_ownership = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "option",
                                      { attrs: { value: "Proprietario" } },
                                      [_vm._v("Proprietario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "Usufruttuario" } },
                                      [_vm._v("Usufruttuario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "Locatario" } },
                                      [_vm._v("Locatario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value: "Promissario acquirente"
                                        }
                                      },
                                      [_vm._v("Promissario acquirente")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value:
                                            "Familiare convivente del possessore/detentore"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Familiare convivente del possessore/detentore"
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "Erede" } },
                                      [_vm._v("Erede")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value: "Coniuge separato assegnatario"
                                        }
                                      },
                                      [_vm._v("Coniuge separato assegnatario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value:
                                            "Socio di cooperativa a proprietà indivisa"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Socio di cooperativa a proprietà indivisa"
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value:
                                            "Socio di cooperativa a proprietà divisa"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Socio di cooperativa a proprietà divisa"
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "niceInputLabel",
                                    attrs: { for: "client_ownership" }
                                  },
                                  [_vm._v("Titolo di possesso *")]
                                ),
                                _vm._v(" "),
                                _vm.errors.has("client_ownership")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\r\n                " +
                                            _vm._s(
                                              _vm.errors.first(
                                                "client_ownership"
                                              )
                                            ) +
                                            "\r\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("h4", { staticClass: "widthFull center black" }, [
                            _vm._v("\r\n            Sede Legale\r\n          ")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-4 mb-3" }, [
                            _c("div", { staticClass: "group custInput" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.address,
                                    expression: "address"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true, max: 128, min: 5 },
                                    expression:
                                      "{required:true, max: 128, min: 5}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("address"),
                                  valid: !!_vm.address
                                },
                                attrs: {
                                  type: "text",
                                  autocomplete: "randomr",
                                  id: "address",
                                  name: "address",
                                  "data-vv-as": "Indirizzo"
                                },
                                domProps: { value: _vm.address },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.address = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "address" }
                                },
                                [_vm._v("Indirizzo *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("address")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\r\n                " +
                                          _vm._s(_vm.errors.first("address")) +
                                          "\r\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-2 mb-3" }, [
                            _c("div", { staticClass: "group custInput" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.civic,
                                    expression: "civic"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true, max: 15 },
                                    expression: "{required:true, max: 15}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("civic"),
                                  valid: !!_vm.civic
                                },
                                attrs: {
                                  type: "text",
                                  autocomplete: "randomt",
                                  id: "civic",
                                  name: "civic",
                                  "data-vv-as": "Civico"
                                },
                                domProps: { value: _vm.civic },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.civic = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "civic" }
                                },
                                [_vm._v("Civico *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("civic")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\r\n                " +
                                          _vm._s(_vm.errors.first("civic")) +
                                          "\r\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-2 mb-3" }, [
                            _c("div", { staticClass: "group custInput" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.cap,
                                    expression: "cap"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true, min: 5, max: 6 },
                                    expression:
                                      "{required:true, min: 5, max: 6}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("cap"),
                                  valid: !!_vm.cap
                                },
                                attrs: {
                                  type: "text",
                                  autocomplete: "randomt",
                                  id: "cap",
                                  name: "cap",
                                  "data-vv-as": "Cap"
                                },
                                domProps: { value: _vm.cap },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.cap = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "cap" }
                                },
                                [_vm._v("Cap *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("cap")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\r\n                " +
                                          _vm._s(_vm.errors.first("cap")) +
                                          "\r\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.item.client_type == "Amministratore di condominio"
                      ? [
                          _c("div", { staticClass: "col-md-12" }, [
                            _c(
                              "h4",
                              { staticClass: "widthFull center black" },
                              [
                                _vm._v(
                                  "\r\n              Completa i dati dell'Amministratore del condominio ("
                                ),
                                _c("b", [
                                  _vm._v(
                                    _vm._s(_vm.item.client_name) +
                                      " " +
                                      _vm._s(_vm.item.client_lastname)
                                  )
                                ]),
                                _vm._v(")\r\n            ")
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-6 mb-3" }, [
                            _c("div", { staticClass: "group custInput" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.quantHouses,
                                    expression: "quantHouses"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true, min: 1, max: 6 },
                                    expression:
                                      "{required:true, min: 1, max: 6}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("quantHouses"),
                                  valid: !!_vm.quantHouses
                                },
                                attrs: {
                                  type: "text",
                                  autocomplete: "randomt",
                                  id: "quantHouses",
                                  name: "quantHouses",
                                  "data-vv-as": "Numero di unità immobiliari"
                                },
                                domProps: { value: _vm.quantHouses },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.quantHouses = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "quantHouses" }
                                },
                                [
                                  _vm._v(
                                    "Numero di unità immobiliari che compongono l’edificio *"
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("quantHouses")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\r\n                " +
                                          _vm._s(
                                            _vm.errors.first("quantHouses")
                                          ) +
                                          "\r\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._m(1),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4 mb-3 " }, [
                      _c(
                        "div",
                        { staticClass: "group custInput" },
                        [
                          _c("datepicker", {
                            attrs: {
                              language: _vm.it,
                              "full-month-name": true,
                              format: "dd MMMM yyyy",
                              "monday-first": true,
                              disabledDates: _vm.disabledDatesStart,
                              id: "eventStartdate",
                              name: "eventStartdate",
                              "input-class": "form-control dateInput"
                            },
                            model: {
                              value: _vm.eventStartdate,
                              callback: function($$v) {
                                _vm.eventStartdate = $$v
                              },
                              expression: "eventStartdate"
                            }
                          }),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: false,
                                expression: "false"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.eventStartdate,
                                expression: "eventStartdate"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true },
                                expression: "{required:true}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("eventStartdate"),
                              valid: !!_vm.eventStartdate
                            },
                            attrs: {
                              type: "text",
                              id: "eventStartdate",
                              name: "eventStartdate",
                              "data-vv-as": "Data inizio"
                            },
                            domProps: { value: _vm.eventStartdate },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.eventStartdate = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "eventStartdate" }
                            },
                            [_vm._v("Data inizio")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("eventStartdate")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\r\n              " +
                                    _vm._s(_vm.errors.first("eventStartdate")) +
                                    "\r\n            "
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4 mb-3 " }, [
                      _c(
                        "div",
                        { staticClass: "group custInput" },
                        [
                          _c("datepicker", {
                            attrs: {
                              language: _vm.it,
                              "full-month-name": true,
                              format: "dd MMMM yyyy",
                              "monday-first": true,
                              disabledDates: _vm.disabledDatesStart,
                              id: "eventEndtdate",
                              name: "eventEndtdate",
                              "input-class": "form-control dateInput"
                            },
                            model: {
                              value: _vm.eventEndtdate,
                              callback: function($$v) {
                                _vm.eventEndtdate = $$v
                              },
                              expression: "eventEndtdate"
                            }
                          }),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: false,
                                expression: "false"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.eventEndtdate,
                                expression: "eventEndtdate"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true },
                                expression: "{required:true}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("eventEndtdate"),
                              valid: !!_vm.eventEndtdate
                            },
                            attrs: {
                              type: "text",
                              id: "eventEndtdate",
                              name: "eventEndtdate",
                              "data-vv-as": "Data ultimazione dei lavori"
                            },
                            domProps: { value: _vm.eventEndtdate },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.eventEndtdate = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "eventEndtdate" }
                            },
                            [_vm._v("Data ultimazione dei lavori (collaudo)")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("eventEndtdate")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\r\n              " +
                                    _vm._s(_vm.errors.first("eventEndtdate")) +
                                    "\r\n            "
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _vm.item.bonus != "Bonus Casa 50%"
                      ? [
                          _vm._m(2),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-md-8 mb-3 pr-4 text-left" },
                            [
                              _c("div", { staticClass: "form-check" }, [
                                _c("div", { staticClass: "p-3" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.noValvole,
                                        expression: "noValvole"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {},
                                        expression: "{}"
                                      }
                                    ],
                                    staticClass: "form-check-input",
                                    class: {
                                      "is-invalid": _vm.errors.has("noValvole")
                                    },
                                    attrs: {
                                      type: "checkbox",
                                      id: "noValvole",
                                      name: "noValvole",
                                      "data-vv-as": ""
                                    },
                                    domProps: {
                                      checked: Array.isArray(_vm.noValvole)
                                        ? _vm._i(_vm.noValvole, null) > -1
                                        : _vm.noValvole
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a = _vm.noValvole,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.noValvole = $$a.concat([
                                                $$v
                                              ]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.noValvole = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.noValvole = $$c
                                        }
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm._m(3),
                                  _vm._v(" "),
                                  _vm.errors.has("noValvole")
                                    ? _c(
                                        "div",
                                        { staticClass: "invalid-feedback" },
                                        [
                                          _vm._v(
                                            "\r\n                  " +
                                              _vm._s(
                                                _vm.errors.first("noValvole")
                                              ) +
                                              "\r\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          !_vm.noValvole
                            ? _c("div", { staticClass: "col-md-12 mb-4" }, [
                                _c("p", { staticClass: "center" }, [
                                  _vm._v(
                                    "Se necessario è possibile selezionare piu di un file"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "front-image" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required: true,
                                          size: 10240,
                                          ext: ["jpeg", "jpg", "png", "pdf"],
                                          mimes: [
                                            "image/jpeg",
                                            "image/jpg",
                                            "image/png",
                                            "application/pdf"
                                          ]
                                        },
                                        expression:
                                          "{required:true,size: 10240, ext: ['jpeg','jpg','png','pdf'], mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}"
                                      }
                                    ],
                                    ref: "fileInput",
                                    staticClass: "fileInput",
                                    class: {
                                      "is-invalid": _vm.errors.has(
                                        "invoiceFront"
                                      ),
                                      valid: !!_vm.invoiceFront,
                                      helper: !!_vm.invoiceFrontBucket
                                    },
                                    attrs: {
                                      type: "file",
                                      multiple: "",
                                      name: "invoiceFront",
                                      id: "invoiceFront",
                                      "data-vv-as":
                                        "Scheda tecnica delle valvole termostatiche"
                                    },
                                    on: { change: _vm.uploadFile }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "highlight" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "bar" }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "niceInputLabel labelFileInput",
                                      attrs: { for: "invoiceFront" }
                                    },
                                    [
                                      !_vm.invoiceFrontName
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "smallText center white",
                                              style: {
                                                backgroundImage:
                                                  "url(" +
                                                  _vm.invoiceFrontBucket +
                                                  ")"
                                              }
                                            },
                                            [
                                              !_vm.invoiceFrontName
                                                ? _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "smallText center white mt-3 mb-0 pb-0"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Scegli il Contratto quadro*"
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        : _c("span", {
                                            staticClass:
                                              "smallText center white",
                                            style: {
                                              backgroundImage:
                                                "url(" +
                                                _vm.invoiceFrontBucket +
                                                ")"
                                            }
                                          })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has("invoiceFront")
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "invalid-feedback",
                                          staticStyle: { top: "185px" }
                                        },
                                        [
                                          _vm._v(
                                            "\r\n                " +
                                              _vm._s(
                                                _vm.errors.first("invoiceFront")
                                              ) +
                                              "\r\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.uploadFrontPercentage
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "progress mt-5",
                                          attrs: { id: "progFront" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "progress-bar ",
                                              style: {
                                                width:
                                                  _vm.uploadFrontPercentage +
                                                  "%"
                                              },
                                              attrs: {
                                                id: "progress-bar-front",
                                                role: "progressbar",
                                                "aria-valuenow": "50",
                                                "aria-valuemin": "0",
                                                "aria-valuemax": "100"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\r\n                  " +
                                                  _vm._s(
                                                    _vm.uploadFrontPercentage
                                                  ) +
                                                  " %\r\n                "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.invoiceFrontName
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "smallText center white mt-3 mb-0 pb-0 fileNameText"
                                        },
                                        [_vm._v(_vm._s(_vm.invoiceFrontName))]
                                      )
                                    : _vm._e()
                                ])
                              ])
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12 mb-3 center mt-5" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: { type: "button" },
                          on: { click: _vm.setAditionalEneaData }
                        },
                        [_vm._v(" Salva ")]
                      )
                    ])
                  ],
                  2
                )
              ]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 pt-md-4 " }, [
      _c("h5", { staticClass: "Regular h0 widthFull" }, [
        _vm._v(
          "Per redigere e inviare la Pratica ENEA abbiamo necessità di ulteriori informazioni"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "black mt-0 widthFull" }, [
        _vm._v(
          "\r\n          Completa il form qui sotto.\r\n          I dati inseriti verranno poi utilizzati per inviare la pratica Enea.\r\n        "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("h4", { staticClass: "widthFull center black" }, [
        _vm._v("\r\n            Inserisci i dati dell'intervento\r\n          ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("h4", { staticClass: "widthFull center black" }, [
        _vm._v(
          "\r\n              Scheda tecnica delle valvole termostatiche\r\n            "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      {
        staticClass: "form-check-label textStable",
        attrs: { for: "noValvole" }
      },
      [
        _c("b", [
          _vm._v(
            "Valvole termostatiche non installate come da relazione allegata alla Dichiarazione di Conformità.\r\n                  "
          ),
          _c("br"),
          _vm._v(
            "Se questo campo viene valorizzato il documento richiesto può essere omesso."
          )
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5414bf37", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5414bf37","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/complateEneaData/index.vue
// module id = null
// module chunks = 